import { render, staticRenderFns } from "./myWrongAssign.vue?vue&type=template&id=24ad61d2&scoped=true"
import script from "./myWrongAssign.vue?vue&type=script&lang=js"
export * from "./myWrongAssign.vue?vue&type=script&lang=js"
import style0 from "./myWrongAssign.vue?vue&type=style&index=0&id=24ad61d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ad61d2",
  null
  
)

export default component.exports